<!-- eslint-disable -->
<template>
  <CommonPages id="blogDetail" :class="['blog-detail']" :title="pageTitle"
    :metaDescription="pageDescription">
    <div class="blog-detail-container" :class="[deviceType]">
      <!-- 博客详情头部 -->
      <div class="blog-header">
        <div class="blog-title">{{ blogData.title }}</div>
        <div v-if="blogData.author" class="blog-author">
          <!-- <img class="author-avatar" :src="blogData.avatar || defaultAvatar" alt="author avatar" /> -->
          <div class="author-name">{{ blogData.author }}</div>
          <div v-if="blogData.publishDate" class="publish-date">Publish: {{ blogData.publishDate }}
          </div>
        </div>
      </div>

      <!-- 博客封面图 -->
      <!-- <div v-if="blogData.image" class="blog-cover">
        <img :src="blogData.image" :alt="blogData.title">
      </div> -->

      <!-- 博客内容 -->
      <div class="blog-content">
        <div class="content-text" v-html="blogData.content"></div>
      </div>

      <!-- 相关推荐部分 -->
      <div class="related-posts">
        <!-- 标题部分 -->
        <div class="related-header">
          <div class="related-title">Relevant Posts</div>
        </div>

        <!-- 博客卡片列表 -->
        <div class="related-cards">
          <div class="related-card" v-for="(card, index) in visiblePosts" :key="index"
            @click="navigateToBlog(card)">
            <img class="card-image" :src="card.image" alt="blog image" />
            <div class="card-info">
              <div class="card-title">{{ card.title }}</div>
              <div class="card-author">
                <!-- <img class="author-avatar" :src="card.avatar" alt="author avatar" /> -->
                <div class="author-name">{{ card.author }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 导航控制区域 -->
        <div class="related-navigation">
          <div class="navigation-buttons">
            <div class="nav-button prev" @click="prevSlide"
              :class="{ 'disabled': currentSlide === 0 }">
              <img src="@/assets/default/arrow-right-small.svg" alt="previous" class="prev-icon" />
            </div>
            <div class="nav-button next" @click="nextSlide"
              :class="{ 'disabled': currentSlide >= Math.ceil(relatedPosts.length / itemsPerSlide) - 1 }">
              <img src="@/assets/default/arrow-right-small.svg" alt="next" class="next-icon" />
            </div>
          </div>

          <div class="view-more-button" @click="goToBlogList">
            <span>View More</span>
            <img src="@/assets/default/arrow-right-small.svg" alt="arrow" class="arrow-icon" />
          </div>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import allBlogs from '@/data/blogs.json'
import '@/css/blog_base.scss';

export default {
  name: 'BlogDetail',
  components: {
    CommonPages
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      blogId: null,
      blogTitle: '',
      currentSlide: 0,
      itemsPerSlide: 4,
      blogData: {
        id: '',
        title: '',
        author: '',
        avatar: '',
        image: '',
        description: '',
        content: ''
      },
      relatedPosts: []
    };
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig',
    ]),
    pageTitle () {
      return this.blogData?.title || '';
    },
    pageDescription () {
      // meta description 以 blogs.json 的 description 为准（与 SEO / 摘要一致）
      const desc = this.blogData?.description;
      if (desc && String(desc).trim()) return String(desc).trim();
      const title = this.blogData?.title || '';
      return title ? `Dive into the story behind ${title}. Learn about naming culture, trends, and meanings.` : '';
    },
    visiblePosts () {
      const start = this.currentSlide * this.itemsPerSlide;
      const end = start + this.itemsPerSlide;
      return this.relatedPosts.slice(start, end);
    }
  },
  watch: {
    '$route.params.id': 'fetchBlogData'
  },
  mounted () {
    // 获取博客数据
    this.fetchBlogData();
  },
  methods: {
    fetchBlogData () {
      this.blogId = this.$route.params.id;
      const blog = allBlogs.find(b => b.id === this.blogId || b.routename === this.blogId);

      if (blog) {
        // 当前域名配置了 blog 白名单时，仅允许名单内 id 展示（防止其它域名通过直链打开未开放文章）
        const whitelist = this.domainConfig?.blog;
        if (whitelist && whitelist.length > 0) {
          const bid = String(blog.id);
          const allowed = whitelist.some((id) => String(id) === bid);
          if (!allowed) {
            this.$router.replace('/blog');
            return;
          }
        }
        this.blogData = blog;
        document.title = this.blogData.title; // 更新页面标题

        // blogs.json 异步进页后 props 才带上 description，需手动刷新 vue-meta 才能更新 head 里的 meta description
        this.$nextTick(() => {
          if (typeof this.$meta === 'function') {
            this.$meta().refresh();
          }
        });

        // 根据domainConfig.blog过滤相关文章，并排除当前文章
        if (this.domainConfig && this.domainConfig.blog && this.domainConfig.blog.length) {
          this.relatedPosts = this.domainConfig.blog
            .map(id => allBlogs.find(b => b.id === String(id)))
            .filter(post => post && post.id !== this.blogData.id);
        } else {
          // 如果domainConfig.blog不存在，则使用默认的相关文章（排除当前篇）
          this.relatedPosts = allBlogs.filter(post => post.id !== this.blogData.id);
        }
      } else {
        console.error(`Blog with ID '${this.blogId}' not found.`);
        // Optionally, redirect to a 404 page
        // this.$router.push('/404');
      }
    },
    prevSlide () {
      if (this.currentSlide > 0) {
        this.currentSlide--;
      }
    },
    nextSlide () {
      const maxSlide = Math.ceil(this.relatedPosts.length / this.itemsPerSlide) - 1;
      if (this.currentSlide < maxSlide) {
        this.currentSlide++;
      }
    },
    navigateToBlog (card) {
      if (card && card.id) {
        // 使用routename生成url slug
        this.$router.push(`/blog/${card.routename}/${card.id}`);
      }
    },
    goToBlogList () {
      this.$router.push('/blog');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.blog-detail {
	// 博客详情容器
	.blog-detail-container {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;

		// 博客头部
		.blog-header {
			padding: rem(52) rem(180);
			display: flex;
			flex-direction: column;
			gap: rem(24);
			align-items: flex-start;
			width: 100%;
			box-sizing: border-box;

			.blog-title {
				color: #03133a;
				font-size: rem(42);
				line-height: rem(52);
				font-weight: 900;
			}

			.blog-author {
				display: flex;
				flex-direction: row;
				gap: rem(12);
				align-items: center;

				.author-avatar {
					border-radius: rem(100);
					border: rem(1) solid rgba(3, 19, 58, 0.1);
					width: rem(32);
					height: rem(32);
					object-fit: cover;
				}

				.author-name {
					color: #374674;
					font-size: rem(16);
					line-height: rem(16);
					font-weight: 400;
					font-style: italic;
				}

				.publish-date {
					color: #374674;
					font-size: rem(16);
					line-height: rem(16);
					font-weight: 400;
					margin-left: rem(20);
				}
			}
		}

		// 博客封面图
		.blog-cover {
			width: 100%;
			padding: 0 rem(180);
			height: rem(480);
			overflow: hidden;
			margin-bottom: rem(40);

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		// 博客内容
		.blog-content {
			padding: 0 rem(180);
			width: 100%;
			box-sizing: border-box;
			margin-bottom: rem(60);

			.content-text {
				color: #03133a;
				font-size: rem(18);
				line-height: rem(32);

				// main.scss 里 body a { color: transparent } 会让 v-html 正文链接「看不见」
				::v-deep a {
					color: #336df4 !important;
					text-decoration: none;
					word-break: break-word;

					&:hover {
						text-decoration: underline;
					}
				}

				h2 {
					font-size: rem(28);
					line-height: rem(36);
					font-weight: 700;
					margin: rem(32) 0 rem(16);
				}

				// 博客 id=41：希腊名字各条加粗标题独占一行（裸文本段落时避免与正文挤在同一行）
				::v-deep h2.blog-41-greek-subheads ~ strong {
					display: block;
					margin-top: rem(20);
				}
				::v-deep h2.blog-41-greek-subheads + strong {
					margin-top: rem(8);
				}

				h3 {
					font-size: rem(22);
					line-height: rem(28);
					font-weight: 700;
					margin: rem(24) 0 rem(12);
				}

				// 博客 id=9：基督徒姓名 2.1–2.6 小节标题（加粗深色、介于原 h2/h3 之间，对齐飞书右侧）
				::v-deep h3.blog-arab-christian-h3 {
					font-size: rem(26);
					line-height: rem(34);
					font-weight: 700;
					color: #03133a;
					margin: rem(28) 0 rem(14);
				}

				p {
					margin-bottom: rem(16);
				}

				// 博客 75–78：独立正文皮肤（仅 .blog-body--{id}，不依赖 blog-section-title / blog-inline-media 等公用 class）
				::v-deep .blog-body--75,
				::v-deep .blog-body--76,
				::v-deep .blog-body--77,
				::v-deep .blog-body--78 {
					font-family: Arial, Helvetica, sans-serif;
					color: #111;

					h2 {
						font-size: rem(20) !important;
						line-height: rem(26) !important;
						font-weight: 700 !important;
						margin: rem(18) 0 rem(12) !important;
						color: #000 !important;
					}

					p {
						font-size: rem(16) !important;
						line-height: rem(26) !important;
						margin: rem(12) 0 !important;
						color: #111 !important;
					}

					ul,
					ol {
						margin: rem(12) 0 rem(12) 0 !important;
						padding-left: rem(28) !important;
					}

					// 全局 reset 给 li 写了 list-style:none，需按类型显式恢复圆点 / 数字（对齐飞书蓝角标）
					ul > li {
						list-style-type: disc !important;
						list-style-position: outside !important;
						font-size: rem(16) !important;
						line-height: rem(26) !important;
						margin: rem(8) 0 !important;

						&::marker {
							color: #336df4;
						}
					}

					ol > li {
						list-style-type: decimal !important;
						list-style-position: outside !important;
						font-size: rem(16) !important;
						line-height: rem(26) !important;
						margin: rem(8) 0 !important;

						&::marker {
							color: #336df4;
							font-weight: 700;
						}
					}

					ol li > p {
						margin: rem(4) 0 !important;
					}

					figure {
						margin: rem(20) 0;

						img {
							width: 100%;
							height: auto;
							display: block;
							// 不使用 max-height + object-fit:cover，否则宽横幅图会被裁掉上下（如博客 77 第二张）
							object-fit: contain;
							border: 1px solid #ddd;
							box-sizing: border-box;
						}

						figcaption {
							font-size: rem(14) !important;
							line-height: rem(20) !important;
							color: #666 !important;
							text-align: center;
							margin: 0 0 rem(20) !important;
						}
					}

					a {
						color: #336df4 !important;
						text-decoration: none !important;
						word-break: break-word;

						&:hover {
							text-decoration: underline !important;
						}
					}
				}

				// 正文内全局 <hr>：1px 浅灰线，去掉浏览器默认 inset 粗线/阴影/底色（与小节线视觉一致）
				::v-deep hr {
					border: 0;
					border-top: 1px solid #e2e8f0;
					margin: rem(24) 0;
					background: none;
					height: 0;
					box-shadow: none;
				}

				// 小节标题内序号（如博客 id=4：蓝色「7.」+ 黑色标题；字号与右侧标题一致）
				::v-deep .blog-section-index {
					color: #336df4;
					font-weight: 700;
					font-size: 1em;
					line-height: inherit;
					vertical-align: baseline;
				}

				// 带序号的小节标题：整行按正文内 h2 字号与间距（blogs v-html 用 p > strong）
				// 使用 .blog-section-title 避免 :has 兼容性问题，并用 !important 压过全局 blog_base 对 p 的字号
				::v-deep p.blog-section-title,
				::v-deep p:has(> strong .blog-section-index) {
					font-size: rem(28) !important;
					line-height: rem(36) !important;
					font-weight: 700;
					margin: rem(32) 0 rem(16);
					color: #03133a;

					> strong {
						font-weight: 700;
						font-size: inherit !important;
						line-height: inherit !important;
						color: inherit;
					}
				}

				// 博客中性名分类（如 id=2）：外层有序号蓝色，内层人名为空心圆点并缩进
				// 注意：全局 reset 对 ol/ul 使用了 list-style:none，此处必须显式恢复
				::v-deep ol.blog-unisex-category-list {
					list-style: decimal outside;
					margin: rem(16) 0 rem(24);
					padding-left: rem(28);
					color: #03133a;
					font-size: rem(18);
					line-height: rem(32);
					font-weight: 400;
					list-style-position: outside;

					> li {
						margin-bottom: rem(20);
						padding-left: rem(4);

						&::marker {
							color: #336df4;
							font-weight: 700;
						}

						> p:first-of-type {
							margin-bottom: rem(10);
							color: #03133a;

							strong {
								font-weight: 700;
								color: #03133a;
							}
						}

						&:last-child {
							margin-bottom: 0;
						}
					}
				}

				// 博客示例块（如 id=5）：左侧竖线、加粗人名 h2 字号 + 下一级「-」列表
				::v-deep blockquote.blog-quote-callout {
					border-left: rem(4) solid #e2e8f0;
					margin: rem(16) 0 rem(24);
					padding: rem(16) rem(20) rem(18) rem(20);
					background: #fafbfd;
					border-radius: 0 rem(8) rem(8) 0;
					color: #03133a;

					// 引言段（如博客 id=24）：斜体 + 略浅灰色，与飞书引用块一致
					&.blog-quote-pull > p {
						margin: 0 !important;
						font-style: italic;
						font-weight: 400;
						color: #374674;
						line-height: rem(32);
					}

					// 同一块引用内多段引言（如博客 id=44：Mixed Reactions）
					&.blog-quote-pull > p + p {
						margin-top: rem(14) !important;
					}

					> .blog-section-title {
						margin: 0 0 rem(14) !important;
						font-size: rem(28) !important;
						line-height: rem(36) !important;
						color: #03133a;

						> strong {
							font-weight: 700;
							color: #03133a;
						}
					}
				}

				::v-deep ul.blog-quote-dash-list {
					list-style: none;
					margin: 0;
					padding: 0;
					color: #374674;
					font-size: rem(18);
					line-height: rem(32);

					> li {
						list-style: none;
						margin: 0 0 rem(10) 0;
						margin-left: 0 !important;

						&:last-child {
							margin-bottom: 0;
						}

						> p {
							position: relative;
							margin: 0 !important;
							padding-left: rem(18);

							&::before {
								content: '-';
								position: absolute;
								left: 0;
								top: 0;
								color: #03133a;
								font-weight: 600;
							}
						}
					}
				}

				// id=5 公共人物小节：2.1 嵌套子列表间距
				// id=8 巴西姓名结构公式：左侧粗蓝条 + 深灰加粗正文（去掉 > 伪引用）
				::v-deep .blog-brazil-name-formula {
					border-left: rem(5) solid #336df4;
					padding: rem(12) 0 rem(12) rem(18);
					margin: rem(16) 0 rem(20);
					background: transparent;
					box-shadow: none;

					p {
						margin: 0 !important;
						color: #3d4a5c;
						font-weight: 700;
						font-size: rem(18);
						line-height: rem(30);
					}

					strong {
						font-weight: 700;
						color: #3d4a5c;
					}
				}

				// id=7 中项嵌套示例：空心圆点子列表（与飞书右侧一致）
				::v-deep ul.blog-middle-name-sublist {
					list-style: circle outside;
					list-style-type: circle;
					margin: rem(10) 0 rem(6);
					padding-left: rem(26);
					font-size: inherit;
					line-height: inherit;

					> li::marker {
						color: #336df4;
					}

					> li > p {
						margin-bottom: 0 !important;
					}
				}

				// 博客 id=25「Reverence for Prophet Names」：外层蓝方块 + 内层空心圆
				::v-deep ul.blog-nested-square-root {
					list-style: square outside;
					list-style-type: square;
					margin: rem(16) 0 rem(20);
					padding-left: rem(26);
					color: #03133a;
					font-size: rem(18);
					line-height: rem(32);

					> li::marker {
						color: #336df4;
					}

					> li > p:first-of-type {
						margin-bottom: rem(6) !important;
					}

					> li > ul.blog-middle-name-sublist {
						margin-top: rem(8);
						margin-bottom: rem(4);
					}
				}

				// 博客 id=50：正文 ul 圆点品牌蓝（飞书右侧实心/空心圆点色）
				::v-deep ul.blog-50-arab-inpage-ul.in-page-ul {
					> li::marker {
						color: #336df4;
					}
				}

				// id=5 Formal Honorifics：圆点与飞书一致用品牌蓝
				::v-deep ul.blog-honorific-list > li::marker {
					color: #336df4;
				}

				// 博客 id=26：男孩名列表序号从 626 起、品牌蓝加粗（与飞书右侧一致）
				::v-deep ol.blog-brazil-boy-num-list {
					margin: rem(16) 0 rem(28);
					padding-left: rem(30);
					color: #03133a;
					font-size: rem(18);
					line-height: rem(32);
					list-style-position: outside;

					> li {
						margin-bottom: rem(20);
						padding-left: rem(6);

						&::marker {
							color: #336df4;
							font-weight: 700;
						}

						&:last-child {
							margin-bottom: 0;
						}

						> p {
							margin: 0 !important;
						}

						// 双段落条目（如 id=27：首行人名加粗、次行说明）
						> p:first-of-type:not(:only-of-type) {
							margin-bottom: rem(8) !important;
						}
					}

					// id=33「Where to Begin」嵌套 ul：与同条内说明段（p）左缘对齐，圆点规则同「Middle Name」in-page-ul（li + rem(35)）
					&.blog-inspiration-module > li > ul.blog-33-inspiration-sublist.in-page-ul {
						font-size: rem(18) !important;
						line-height: rem(32) !important;
						color: #374674 !important;
						margin: rem(8) 0 rem(12) !important;
						margin-left: 0 !important;
						padding-left: 0 !important;

						> li {
							list-style: disc outside !important;
							list-style-type: disc !important;
							margin-left: rem(35) !important;
							padding-left: 0 !important;

							&::marker {
								color: #374674;
							}

							> p {
								margin: 0 0 rem(4) !important;
							}

							&:last-child > p {
								margin-bottom: 0 !important;
							}
						}
					}
				}

				// 博客 id=47：第二段「Name Rankings」序号 8–20，人名略大、说明行字色与间距贴近飞书
				::v-deep ol.blog-47-rankings-ol {
					margin: rem(18) 0 rem(32);

					> li {
						margin-bottom: rem(24);

						&::marker {
							font-size: rem(18);
						}

						> p:first-of-type strong {
							font-size: rem(22);
							line-height: rem(30);
							font-weight: 700;
						}

						> p + p {
							color: #374674;
							line-height: rem(32);
						}
					}
				}

				::v-deep ul.blog-public-figure-list {
					margin-top: rem(8);
					margin-bottom: rem(4);

					ul.blog-public-figure-sublist {
						margin-top: rem(10);
						margin-bottom: rem(4);
					}
				}

				::v-deep ul.blog-unisex-name-bullets {
					list-style: circle outside;
					list-style-type: circle;
					margin: 0 0 rem(4) 0;
					padding-left: rem(28);
					color: #03133a;
					font-size: rem(18);
					line-height: rem(32);

					> li {
						margin-bottom: rem(6);
						margin-left: 0;

						&::marker {
							color: #374674;
						}

						&:last-child {
							margin-bottom: 0;
						}

						p {
							margin-bottom: 0;
						}
					}
				}

				// 正文内数据表：与正文内插图同宽（通栏 100%）
				::v-deep table.blog-inline-table {
					width: 100%;
					max-width: 100%;
					table-layout: fixed;
					border-collapse: separate;
					border-spacing: 0;
					margin: rem(16) 0 rem(24);
					font-size: rem(14);
					line-height: rem(22);
					color: #03133a;
					border: 1px solid rgba(3, 19, 58, 0.1);
					border-radius: rem(10);
					overflow: hidden;
					box-shadow: 0 1px rem(8) rgba(3, 19, 58, 0.04);

					thead th {
						text-align: center;
						font-weight: 600;
						color: #374674;
						background: linear-gradient(180deg, #fafbfd 0%, #f0f3f9 100%);
						padding: rem(6) rem(10);
						border-right: 1px solid rgba(3, 19, 58, 0.08);
						border-bottom: 1px solid rgba(3, 19, 58, 0.1);
						// 与表体同字号，避免「Origin」列视觉小于后两列
						font-size: rem(14);
						letter-spacing: 0.01em;
						white-space: nowrap;
					}

					thead th:nth-child(1) {
						width: 24%;
					}

					thead th:nth-child(2),
					thead th:nth-child(3) {
						width: 38%;
					}

					thead th:last-child {
						border-right: none;
					}

					tbody td {
						padding: rem(6) rem(10);
						border-right: 1px solid rgba(3, 19, 58, 0.08);
						border-bottom: 1px solid rgba(3, 19, 58, 0.08);
						vertical-align: middle;
						font-size: rem(14);
					}

					tbody td:last-child {
						border-right: none;
					}

					tbody tr:last-child td {
						border-bottom: none;
					}

					tbody td:first-child {
						text-align: left;
						font-weight: 600;
						color: #03133a;
						word-wrap: break-word;
					}

					tbody td:first-child strong {
						font-weight: 600;
						font-size: inherit;
					}

					tbody td:nth-child(2),
					tbody td:nth-child(3) {
						text-align: center;
						color: #1e2b4d;
						font-weight: 400;
						overflow-wrap: anywhere;
					}
				}

				// v-html 注入的节点不受 scoped 限制，需穿透样式
				::v-deep figcaption.tips {
					display: block;
					font-size: rem(14);
					line-height: rem(22);
					color: #374674;
					text-align: center;
					margin: rem(12) auto rem(24);
					font-style: normal;
				}

				// 与 figcaption.tips（如 Choose a name）视觉一致的正文说明行
				::v-deep p.blog-caption-tips {
					display: block;
					font-size: rem(14);
					line-height: rem(22);
					color: #374674;
					text-align: center;
					margin: rem(12) auto rem(24);
					font-style: normal;
					font-weight: 400;
				}

				::v-deep a.blog-content-link {
					color: #336df4;
					text-decoration: none;

					&:hover {
						text-decoration: underline;
					}
				}

				// 实心圆点列表（正文 ol/ul 配套），与早期 PDF 风格一致
				::v-deep ul.blog-pdf-bullet {
					padding-left: rem(22);
					margin: rem(10) 0;

					li {
						margin-left: 0;
						margin-bottom: rem(10);

						&:last-child {
							margin-bottom: 0;
						}
					}

					li > p {
						margin-bottom: 0 !important;
					}

					li > ul,
					li > ol {
						margin-top: rem(10);
						margin-bottom: 0;
					}

					li::marker {
						color: #336df4;
						font-size: rem(14);
					}
				}

				// 「Why these names work」类区块：大标题 + 正文 + 蓝点列表 + 浅灰分隔线（如博客 62）
				::v-deep .blog-pdf-why-block {
					margin: rem(8) 0 rem(28);

					h3:first-child {
						margin-top: rem(12);
						margin-bottom: rem(12);
						color: #03133a;
					}

					> p {
						color: #03133a;
					}

					ul.blog-pdf-bullet {
						margin-top: rem(8);
						margin-bottom: rem(4);

						li p {
							color: #03133a;
						}
					}

					hr.blog-pdf-section-rule {
						border: 0;
						border-top: 1px solid #e2e8f0;
						margin: rem(20) 0 0;
					}
				}

				// 名称 + 说明分行（右侧稿：加粗名一行，说明次行，无圆点）
				::v-deep ul.blog-pdf-name-stack {
					list-style: none;
					padding-left: 0;
					margin: rem(8) 0 rem(28);

					> li {
						list-style: none !important;
						margin-left: 0 !important;
						margin-bottom: rem(20);
						padding-left: 0;

						&::marker {
							content: none;
						}

						&:last-child {
							margin-bottom: 0;
						}

						> p:first-of-type {
							margin-bottom: rem(6);

							strong {
								color: #03133a;
								font-weight: 700;
							}
						}

						> p + p {
							margin-bottom: 0;
							color: #03133a;
							font-size: rem(18);
							line-height: rem(32);
							font-weight: 400;
						}
					}
				}

				// 数字有序列表（非 h3 内角标），恢复默认加粗角标与常规缩进
				::v-deep ol.blog-pdf-num {
					padding-left: rem(26);
					margin: rem(10) 0;
					// 覆盖 blog_base .in-page-ol 的 rem(22)，与正文段落字号一致
					font-size: rem(18);
					line-height: rem(32);
					font-weight: 400;
					color: #03133a;

					li {
						margin-left: 0;
						margin-bottom: rem(10);

						&:last-child {
							margin-bottom: 0;
						}
					}

					li > p {
						margin-bottom: 0 !important;
					}

					li > ul,
					li > ol {
						margin-top: rem(10);
						margin-bottom: 0;
					}

					// 嵌套要点：blog_base .in-page-ol li 会把 ol 内所有后代 li 变成 decimal，这里强制实心圆点
					li > ul.in-page-ul.blog-pdf-bullet {
						list-style: disc;
						padding-left: rem(22);

						> li {
							list-style: disc !important;
							margin-left: 0;
						}

						> li::marker {
							color: #336df4;
							font-size: rem(14);
						}
					}

					li::marker {
						color: #336df4;
						font-weight: 700;
						font-size: rem(14);
					}
				}

				// 步骤列表：正文已写 Step 1 / 加粗标题，隐藏 ol 自动序号（覆盖 blog_base .in-page-ol）
				// 注意：必须用 > li，否则步骤内嵌套的 ul > li 会被去掉圆点
				::v-deep ol.blog-pdf-step {
					list-style: none;
					padding-left: 0;
					margin: rem(8) 0 rem(28);

					> li {
						list-style: none !important;
						margin-left: 0 !important;
						padding-left: 0;
						margin-bottom: rem(24);

						&::marker {
							content: none;
						}

						&:last-child {
							margin-bottom: 0;
						}
					}

					// 步骤标题：与正文同色，不加蓝；前导数字角标（如海洋主题博客 60）
					.blog-pdf-step-heading {
						display: flex;
						align-items: center;
						margin-bottom: rem(8);
						.blog-pdf-step-sup {
							color: #336df4;
							font-weight: 700;
							font-size: rem(14);
							line-height: 0;
							vertical-align: super;
							margin-right: rem(6);
						}

						strong {
							color: #03133a;
							font-weight: 700;
						}
					}

					// 步骤内嵌套要点列表（实心圆点）
					ul.blog-pdf-bullet {
						list-style: disc;
						padding-left: rem(22);
						margin-top: rem(4);
						margin-bottom: rem(8);

						li {
							list-style: disc !important;
							margin-left: 0;
						}

						li::marker {
							color: #336df4;
							font-size: rem(14);
						}
					}
				}

				// FAQ 列表：无左侧圆点/序号（覆盖全局 .in-page-ol li 的 list-style）
				::v-deep ul.blog-faq-list {
					list-style: none;
					padding-left: 0;
					margin: rem(8) 0 rem(20);

					li {
						list-style: none;
						margin-left: 0;
						padding-left: 0;
						margin-bottom: rem(16);

						&::marker {
							content: none;
						}
					}
				}

				// FAQ：蓝色数字 1、2、3…；与正文左缘对齐（覆盖 blog_base .in-page-ol li 的大 margin-left）
				::v-deep ol.blog-faq-num {
					list-style: decimal;
					list-style-position: outside;
					padding-left: rem(24);
					margin: rem(8) 0 rem(20);
					margin-left: 0 !important;
					font-size: rem(18);
					line-height: rem(32);
					font-weight: 400;

					li {
						margin-left: 0 !important;
						margin-bottom: rem(16);
						padding-left: rem(4);

						// 问答两行都与序号后的正文齐平，不再多出一段缩进
						p {
							margin-left: 0;
							padding-left: 0;
						}

						&::marker {
							color: #336df4;
							font-weight: 700;
							font-size: rem(16);
						}
					}
				}

				// 兼容：仍使用 ol + 伪元素 Q1… 时的样式（若某篇 FAQ 未内嵌 Q 文案）
				::v-deep ol.blog-faq-qnum {
					list-style: none;
					padding-left: 0;
					margin: rem(8) 0 rem(20);
					counter-reset: blog-faq-q;

					li {
						position: relative;
						margin-left: 0;
						padding-left: rem(48);
						margin-bottom: rem(4);
						list-style: none;

						counter-increment: blog-faq-q;

						&::marker {
							content: none;
						}

						&::before {
							content: 'Q' counter(blog-faq-q) ' ';
							position: absolute;
							left: 0;
							top: 0;
							color: #03133a;
							font-weight: 700;
							font-size: rem(18);
							line-height: rem(32);
						}
					}
				}

				// PDF 二级圆点 ◦（hollow circle），与一级实心圆点区分层级
				::v-deep ul.blog-pdf-subbullet {
					padding-left: rem(20);
					margin: rem(6) 0 rem(12);
					list-style-type: circle;

					li::marker {
						color: #336df4;
						font-size: rem(12);
					}
				}

				::v-deep ul.blog-pdf-bullet ul.blog-pdf-subbullet {
					margin-top: rem(6);
					margin-bottom: rem(4);
				}

				// h3 内分类序号（如「1. Nature-Inspired Spring Names」）：仅这类角标用小号、不加粗
				::v-deep .blog-pdf-h3-num {
					color: #336df4;
					// 相对同一行 h3 正文字号约小一号，随桌面/移动端 h3 缩放
					font-size: 0.85em;
					// 比 400 略粗、弱于标题 700，避免和后面粗体标题完全同一档
					font-weight: 600;
				}

				// 博客正文对比表
				::v-deep .blog-table-wrap {
					overflow-x: auto;
					margin: rem(16) 0 rem(24);
					-webkit-overflow-scrolling: touch;
				}

				::v-deep .blog-comparison-table {
					width: 100%;
					min-width: rem(420);
					border-collapse: collapse;
					font-size: rem(16);
					line-height: rem(24);
					color: #03133a;

					th,
					td {
						border: 1px solid #dce3ef;
						padding: rem(12) rem(14);
						text-align: left;
						vertical-align: top;
					}

					thead th {
						background: #f4f7fc;
						font-weight: 700;
					}

					tbody th[scope='row'] {
						font-weight: 600;
						background: #fafbfd;
					}
				}

				// 正文配图与段落同宽（与正文齐平，不超出内容区）
				::v-deep figure.blog-inline-media {
					width: 100%;
					max-width: 100%;
					margin: rem(16) 0;
					margin-left: 0;
					margin-right: 0;

					img {
						width: 100%;
						max-width: 100%;
						height: auto;
						display: block;
					}
				}

				::v-deep p > img {
					width: 100%;
					max-width: 100%;
					height: auto;
					display: block;
				}
			}
		}

		// 相关推荐部分
		.related-posts {
			width: 100%;
			padding: 0 rem(180) rem(60);
			box-sizing: border-box;

			.related-header {
				margin-bottom: rem(32);

				.related-title {
					color: #03133a;
					font-size: rem(28);
					line-height: rem(28);
					font-weight: 900;
				}
			}

			.related-cards {
				display: flex;
				flex-wrap: wrap;
				gap: rem(24);
				margin-bottom: rem(40);

				.related-card {
					width: calc(25% - rem(18)); // 每行4个卡片
					display: flex;
					flex-direction: column;
					cursor: pointer;
					transition: all 0.3s ease;
					border-radius: rem(36);
					border: rem(1) solid transparent;

					&:hover {
						border: rem(1) solid #a31984;
					}

					.card-image {
						border-radius: rem(36) rem(36) 0 0;
						border: rem(1) solid rgba(3, 19, 58, 0.04);
						height: rem(168);
						width: 100%;
						object-fit: cover;
					}

					.card-info {
						padding: rem(16) rem(20) rem(24);
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						height: rem(120);
						background: #f7f3f3;
						border-radius: 0 0 rem(36) rem(36);

						.card-title {
							color: #03133a;
							font-size: rem(16);
							line-height: rem(20);
							font-weight: 700;
						}

						.card-author {
							display: flex;
							flex-direction: row;
							gap: rem(8);
							align-items: center;

							.author-avatar {
								border-radius: rem(100);
								border: rem(1) solid rgba(3, 19, 58, 0.1);
								width: rem(24);
								height: rem(24);
								object-fit: cover;
							}

							.author-name {
								color: #374674;
								font-size: rem(12);
								line-height: rem(12);
								font-weight: 400;
								font-style: italic;
							}
						}
					}
				}
			}

			// 导航控制区域
			.related-navigation {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;

				.navigation-buttons {
					display: flex;
					gap: rem(16);

					.nav-button {
						width: rem(28);
						height: rem(28);
						border-radius: rem(20);
						background-color: #a31984;
						display: flex;
						align-items: center;
						justify-content: center;
						cursor: pointer;
						transition: all 0.3s ease;

						&:hover {
							opacity: 0.8;
						}

						&.disabled {
							opacity: 0.5;
							cursor: not-allowed;
						}

						.prev-icon {
							transform: rotate(180deg);
							width: rem(6);
							height: rem(12);
							filter: brightness(0) invert(1);
						}

						.next-icon {
							width: rem(6);
							height: rem(12);
							filter: brightness(0) invert(1);
						}
					}
				}

				.view-more-button {
					border-radius: rem(12);
					border: rem(1) solid #a31984;
					padding: rem(8) rem(16);
					display: flex;
					gap: rem(8);
					align-items: center;
					cursor: pointer;
					transition: all 0.3s ease;

					&:hover {
						background: #a31984;

						span {
							color: #ffffff;
						}

						.arrow-icon {
							filter: brightness(0) invert(1);
						}
					}

					span {
						color: #a31984;
						font-size: rem(16);
						line-height: rem(16);
						font-weight: 700;
					}

					.arrow-icon {
						width: rem(6);
						height: rem(12);
					}
				}
			}
		}

		// 移动端样式
		&.mobile {
			.blog-header {
				padding: rem(32) rem(16);

				.blog-title {
					font-size: rem(28);
					line-height: rem(36);
				}
			}

			.blog-cover {
				height: rem(240);
				padding: 0 rem(16);
			}

			.blog-content {
				padding: 0 rem(16);

				.content-text {
					font-size: rem(16);
					line-height: rem(28);

					h2 {
						font-size: rem(24);
						line-height: rem(32);
					}

					// 博客 75–78 移动端：与桌面独立皮肤同一字体阶梯略收紧
					::v-deep .blog-body--75,
					::v-deep .blog-body--76,
					::v-deep .blog-body--77,
					::v-deep .blog-body--78 {
						h2 {
							font-size: rem(18) !important;
							line-height: rem(24) !important;
						}

						p,
						ul > li,
						ol > li {
							font-size: rem(15) !important;
							line-height: rem(24) !important;
						}

						figure figcaption {
							font-size: rem(13) !important;
						}
					}

					h3 {
						font-size: rem(20);
						line-height: rem(24);
					}

					::v-deep h3.blog-arab-christian-h3 {
						font-size: rem(20);
						line-height: rem(28);
					}

					::v-deep p.blog-section-title,
					::v-deep p:has(> strong .blog-section-index) {
						font-size: rem(24) !important;
						line-height: rem(32) !important;
					}

					::v-deep blockquote.blog-quote-callout > .blog-section-title {
						font-size: rem(24) !important;
						line-height: rem(32) !important;
					}

					::v-deep blockquote.blog-quote-callout.blog-quote-pull > p {
						line-height: rem(28);
					}

					::v-deep ul.blog-quote-dash-list {
						font-size: rem(16);
						line-height: rem(28);
					}

					::v-deep ul.blog-nested-square-root {
						font-size: rem(16);
						line-height: rem(28);
					}

					::v-deep ol.blog-brazil-boy-num-list {
						font-size: rem(16);
						line-height: rem(28);

						> li {
							margin-bottom: rem(16);

							> p:first-of-type:not(:only-of-type) {
								margin-bottom: rem(6) !important;
							}
						}

						&.blog-inspiration-module > li > ul.blog-33-inspiration-sublist.in-page-ul {
							font-size: rem(16) !important;
							line-height: rem(28) !important;
							margin-left: 0 !important;

							> li {
								margin-left: rem(35) !important;

								> p {
									margin-bottom: rem(4) !important;
								}
							}
						}
					}

					::v-deep ol.blog-47-rankings-ol {
						> li {
							margin-bottom: rem(20);

							> p:first-of-type strong {
								font-size: rem(19);
								line-height: rem(26);
							}

							> p + p {
								font-size: rem(16);
								line-height: rem(28);
							}
						}
					}

					::v-deep .blog-brazil-name-formula p {
						font-size: rem(16);
						line-height: rem(28);
					}

					::v-deep ol.blog-unisex-category-list,
					::v-deep ul.blog-unisex-name-bullets {
						font-size: rem(16);
						line-height: rem(28);
					}

					::v-deep ol.blog-faq-qnum li::before {
						font-size: rem(16);
						line-height: rem(28);
					}

					::v-deep ol.blog-faq-num li::marker {
						font-size: rem(15);
					}

					::v-deep table.blog-inline-table {
						font-size: rem(13);
						line-height: rem(20);

						thead th {
							padding: rem(6) rem(10);
							// 与移动端表体同字号
							font-size: rem(13);
						}

						tbody td {
							padding: rem(6) rem(10);
							font-size: rem(13);
						}
					}
				}
			}

			.related-posts {
				padding: 0 rem(16) rem(40);

				.related-header {
					margin-bottom: rem(24);

					.related-title {
						font-size: rem(24);
						line-height: rem(24);
					}
				}

				.related-cards {
					flex-direction: column;
					gap: rem(16);
					margin-bottom: 0;

					.related-card {
						width: 100%;
						margin-bottom: rem(16);
					}
				}

				.related-navigation {
					flex-direction: column;
					gap: rem(16);
					align-items: center;

					.navigation-buttons {
						margin-bottom: rem(16);
					}

					.view-more-button {
						width: 100%;
						justify-content: center;
					}
				}
			}
		}
	}
}
</style> 